import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import Icon from '../../../components/AppIcon';

const MemberAnalytics = ({ data }) => {
  const COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6'];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Member Analytics</h2>
        <p className="text-sm text-gray-600">Demographics and retention insights</p>
      </div>
      {/* Key Metrics */}
      <div className="grid grid-cols-2 gap-4 mb-6">
        <div className="bg-blue-50 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Users" className="w-5 h-5 text-blue-600" />
            <span className="text-sm font-medium text-gray-600">Total Members</span>
          </div>
          <p className="text-2xl font-bold text-gray-900">{data?.totalMembers}</p>
          <p className="text-xs text-green-600 mt-1">+{data?.newThisMonth} this month</p>
        </div>
        
        <div className="bg-green-50 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="TrendingUp" className="w-5 h-5 text-green-600" />
            <span className="text-sm font-medium text-gray-600">Retention Rate</span>
          </div>
          <p className="text-2xl font-bold text-gray-900">{data?.retentionRate}%</p>
          <p className="text-xs text-gray-500 mt-1">Churn: {data?.churnRate}%</p>
        </div>
      </div>
      {/* Age Demographics Chart */}
      <div className="mb-6">
        <h3 className="text-sm font-semibold text-gray-900 mb-4">Age Demographics</h3>
        <ResponsiveContainer width="100%" height={200}>
          <PieChart>
            <Pie
              data={data?.demographics}
              dataKey="count"
              nameKey="ageGroup"
              cx="50%"
              cy="50%"
              outerRadius={80}
              label={({ ageGroup, percentage }) => `${ageGroup} (${percentage}%)`}
              labelLine={false}
            >
              {data?.demographics?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS?.[index % COLORS?.length]} />
              ))}
            </Pie>
            <Tooltip formatter={(value) => `${value} members`} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      {/* Membership Types */}
      <div>
        <h3 className="text-sm font-semibold text-gray-900 mb-3">Membership Types</h3>
        <div className="space-y-3">
          {data?.membershipTypes?.map((type, index) => (
            <div key={index} className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div 
                  className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: COLORS?.[index % COLORS?.length] }}
                />
                <span className="text-sm font-medium text-gray-700">{type?.type}</span>
              </div>
              <div className="text-right">
                <p className="text-sm font-semibold text-gray-900">{type?.count} members</p>
                <p className="text-xs text-gray-500">${type?.revenue?.toLocaleString()}/mo</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MemberAnalytics;